export const DATE_FORMAT = 'MM/DD/YYYY';
export const MONTH_FORMAT = 'MMMM';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DATE_TIME_SECOND_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const BACKEND_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const MAX_BATCH_RECIPIENTS = 5000;
